
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.102.719c-.23.057-.396.114-.5.172a.754.754 0 00-.243.218 1.01 1.01 0 00-.132.383c-.027.172-.04.438-.04.797v6.758c0 .349.01.604.032.765.026.162.065.29.117.383a.698.698 0 00.242.235c.11.062.284.125.524.187V11H8.844v-.383c.297-.073.502-.156.617-.25a.722.722 0 00.234-.414c.042-.182.063-.484.063-.906V6.055c0-.787.01-1.581.031-2.383.026-.807.055-1.36.086-1.656h-.133L6.648 9.758H5.75L2.875 1.89h-.133c.026.317.05.893.07 1.726.027.834.04 1.69.04 2.57v2.86c0 .349.01.604.03.765.027.162.066.29.118.383a.697.697 0 00.242.235c.11.062.284.125.524.187V11H.914v-.383c.323-.083.54-.174.648-.273.11-.104.18-.25.211-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.914.72V.336h2.79l2.741 7.602L9.461.335h2.64v.383z","fill":"currentColor"}})])
          )
        }
      }
    